import EnrolmentsAdapter from './base';

export default class Rollreturn extends EnrolmentsAdapter {
  modelNamePlural = 'rollreturns';
}
